var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{on:{"click":_setup.increment}},[_vm._v("Count is: "+_vm._s(_setup.count))])
}
var staticRenderFns = []

export { render, staticRenderFns }